import { gql } from '@apollo/client'
import { IQueryBasicData, ID } from '../IQueryData'

export interface IGetParkingPoolAvailabilityVars {
  parkingPool: ID
  login: string
  from: string
  to: string
}

export type ParkingPoolAvailabilityReasonCode =
  | 'POOL_FULL'
  | 'ALREADY_RESERVED'
  | 'BEYOND_MAX_ADVANCE'
  | 'IN_THE_PAST'
  | 'USER_RESERVATION_LIMIT'
  | 'PARKING_USER_LIMIT'
  | 'POOL_USER_LIMIT'
  | 'PROFILE_USER_LIMIT'
  | 'POOL_NOT_VALID'
  | 'PASS_DISABLED'
  | 'NO_PARKING_ASSIGNED'

export interface IParkingPoolAvailabilityDay {
  date: string
  available: boolean
  slotsLeft: number | null
  reason: string | null
  reasonCode: ParkingPoolAvailabilityReasonCode | null
}

export interface IReservationVariantDay {
  day: string
  parkingName: string
  poolParkingId: ID
  available: boolean
  reason: string | null
  reasonCode: ParkingPoolAvailabilityReasonCode | null
}

export interface IReservationVariant {
  score: number
  days: IReservationVariantDay[]
}

export interface IGetParkingPoolAvailabilityData {
  getParkingPoolAvailability: IQueryBasicData & {
    orderingEnabled: boolean
    maxAdvanceDays: number
    maxDurationDays: number
    maxReservationCountPerUser: number
    days: IParkingPoolAvailabilityDay[]
    variants: IReservationVariant[]
  }
}

export const GET_PARKING_POOL_AVAILABILITY = gql`
  query getParkingPoolAvailability(
    $parkingPool: ID!
    $login: String!
    $from: DateTime!
    $to: DateTime!
  ) {
    getParkingPoolAvailability(
      parking_pool: $parkingPool
      login: $login
      from: $from
      to: $to
    ) {
      status
      code
      error
      message
      orderingEnabled: ordering_enabled
      maxAdvanceDays: max_advance_days
      maxDurationDays: max_duration_days
      maxReservationCountPerUser: max_reservation_count_per_user
      days {
        date
        available
        slotsLeft: slots_left
        reason
        reasonCode: reason_code
      }
      variants {
        score
        days {
          day
          parkingName: parking_name
          poolParkingId: pool_parking_id
          available
          reason
          reasonCode: reason_code
        }
      }
    }
  }
`
